<template>
  <div class="lt">

    <div class="lt-bottom">
      <div class="lt-bt-item" v-for="(item, index) in dataMap" :key="index">
        <div class="lt-item-content">
          <img src="../../assets/template3/btimg.png" alt="" class="bt-bg-img" />

          <div class="item-num" >{{ item.num1 }}</div>
          <div class="lt-item-title">{{ item.name + '(' + item.unit + ')' }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'template.leftT-temp3',
  data() {
    return {
      //线路列表
      topMap: [],
      select: {},
      // 已选高速详情列表 name描述 val蓝色字体 unit白色字体
      dataMap: [
        { name: "国有林地", val: "mu", num1: '414', unit: "亩" },
        { name: "基本农田", val: "mu", num1: '414', unit: "亩" },
        { name: "一般耕地", val: "mu", num1: '414', unit: "亩" },
        { name: "林地", val: "mu", num1: '414', unit: "亩" },
        { name: "商业用地", val: "mu", num1: '414', unit: "亩" },
        { name: "总面积", val: "ha", num1: '414', unit: "公顷" },
        { name: "建设用地", val: "mu", num1: '414', unit: "亩" },
        { name: "闲置土地", val: "mu", num1: '414', unit: "亩" },
      ],
    };
  },
  watch: {},
  methods: {
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.lt {
  width: 435px;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
}

.lt-bottom {
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
}

.lt-bt-item {
  width: 100px;
  height: 100px;
  position: relative;
  margin: -26px 0 0;
  display: flex;
  // flex-direction: column;
}

.lt-bt-item:nth-child(4n + 1) {
  margin-left: 0;
}

.bt-bg-img {
  // position: absolute;
  width: 94px;
  height: 115px;
}

.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 36px;
  top: 20px;
}

.lt-item-title {
  margin: 46px 0 0 18px;
  width: 83px;
  height: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #70ADAC;
  line-height: 15px;
}

.item-num {
  margin: -58px 0 0 26px;
  width: 46px;
  height: 19px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 25px;
  color: #FFFFFF;
  line-height: 15px;

}

.item-val {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #AFC2DF;
  line-height: 19px;
}

.item-unit {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a6bbd9;
  line-height: 19px;
  margin-left: 4px;
}
</style>